export default __webpack_public_path__ + "static/media/Coche-seguro.d20a15cd.svg";